<template>
    <activation-brief-tasks-provider
        v-slot="{
            brief,
            contact,
            step,
            patchStep,
            goNextStep,
            goPreviousStep,
            isPreview,
            isLoading,
            isCompletingBrief,
            errors,
            errorMessage,
            hideContentApprovalOnboarding,
            context
        }"
        class="g-h-full"
    >
        <activation-brief-tasks-view
            :brief="brief"
            :contact="contact"
            :step="step"
            :is-loading="isLoading"
            :is-completing-brief="isCompletingBrief"
            :errors="errors"
            :error-message="errorMessage"
            :context="context"
            @go-next-step="goNextStep"
            @go-previous-step="goPreviousStep"
            @patch-step="patchStep"
            @hide-content-approval-onboarding="hideContentApprovalOnboarding"
        />
    </activation-brief-tasks-provider>
</template>

<script>
    import ActivationBriefTasksProvider from '../providers/activation-brief-steps/ActivationBriefTasksProvider.vue';
    import ActivationBriefTasksView from '../data-views/activation-briefs/ActivationBriefTasksView.vue';

    export default {
        name: 'ActivationBriefTasksRouterView',
        components: {
            ActivationBriefTasksView,
            ActivationBriefTasksProvider
        }
    };
</script>
